import objectAssign from 'object-assign';
import _ from 'lodash';
import * as types from '../constants/actionTypes';
import 'whatwg-fetch';
import toastr from 'toastr';

let serverUrl = 'http://localhost:8000';
if (process.env.NODE_ENV === 'production') {
  serverUrl = 'https://arrangement.amerikanskeidretter.no';
}

let defaultDelay = 0;
if (process.env.NODE_ENV === 'development') {
  defaultDelay = 200;
}


// Load List
export function loadList(url, success_type, failure_type, success_cb, failure_cb) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    getData(url,
      (result) => {dispatch(loadListSuccess(result, success_type, success_cb));},
      (error) => {dispatch(loadFailure(error, failure_type, failure_cb));},
      defaultDelay);
  };
}

export function loadListSuccess(list, success_type, success_cb) {
  return function(dispatch) {
    dispatch({
      type: types[success_type], // eslint-disable-line import/namespace
      list: list,
      listUpdated: Date.now(),
    });
    if (success_cb) {
      success_cb();
    }
  };
}

// Load details
export function loadDetails(url, success_type, failure_type, success_cb, failure_cb) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    getData(url,
      (result) => {dispatch(detailsSuccess(result, success_type, success_cb));},
      (error) => {dispatch(loadFailure(error, failure_type, failure_cb));},
      defaultDelay);
  };
}

export function update(url, details, success_type, failure_type, success_cb, failure_cb) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    sendData(url, 'PUT', details,
      (result) => {dispatch(detailsSuccess(result, success_type, success_cb));},
      (error) => {dispatch(loadFailure(error, failure_type, failure_cb));},
      defaultDelay);
  };
}

export function create(url, details, success_type, failure_type, success_cb, failure_cb) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    sendData(url, 'POST', details,
      (result) => {dispatch(detailsSuccess(result, success_type, success_cb));},
      (error) => {dispatch(loadFailure(error, failure_type, failure_cb));},
      defaultDelay);
  };
}

export function detailsSuccess(details, success_type, success_cb) {
  return function(dispatch) {
    dispatch({
      type: success_type, // eslint-disable-line import/namespace
      details: details,
      detailsUpdated: Date.now(),
    });
    if (success_cb) {
      success_cb(details);
    }
  };
}

// Failure
export function loadFailure(error, failure_type, failure_cb) {
  return function(dispatch) {
    dispatch({
      type: failure_type, // eslint-disable-line import/namespace
      errors: error,
    });
    if (failure_cb) {
      failure_cb(error);
    }
  };
}


// General utils
export function beginAjaxCall() {
  return {
    type: types.BEGIN_AJAX_CALL,
  };
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    let error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

function parseJSON(response) {
  return response.json();
}

function parseJSONStream(response) {
  return response.text();
}

function handleError(error) {
  if(error.response) {
    return error.response;
  } else {
    toastr.error(error, 'Feilmelding:');
    return error;
  }
}

export function getData(url, successCb, failCb, delay) {
  let cb = successCb;
  fetch(serverUrl+'/api/v1/' + url + '?format=json', {
    headers: {
      Authorization: "Token " + localStorage.token,
    },
  }).then(checkStatus)
    .catch(function(error) {
      cb = failCb;
      return handleError(error);
    })
    .then(parseJSON)
    .then(function(result) {
      if(cb != undefined && delay > 0) {
        setTimeout(function() {
          cb(result);
        }, delay);
      } else if(cb != undefined) {
        cb(result);
      }
    });
}

export function streamData(url, successCb, failCb, delay) {
  let cb = successCb;
  fetch(serverUrl+'/api/v1/' + url + '?format=json', {
    headers: {
      Authorization: "Token " + localStorage.token,
    },
  }).then(checkStatus)
    .catch(function(error) {
      cb = failCb;
      return handleError(error);
    })
    .then(parseJSONStream)
    .then(function(result) {
      if(cb != undefined && delay > 0) {
        setTimeout(function() {
          cb(result);
        }, delay);
      } else if(cb != undefined) {
        cb(result);
      }
    });
}

export function deleteData(url, callback) {
  fetch(serverUrl+'/api/v1/' + url + '?format=json', {
    method: 'DELETE',
    headers: {
      Authorization: "Token " + localStorage.token,
    },
  }).then(function(response) {
      callback(response);
  }).catch(function(error) {
    toastr.error(error, 'Feilmelding:');
  });
}

export function sendData(url, method, data, successCb, failCb, delay) {
  let cb = successCb;
  fetch(serverUrl+'/api/v1/' + url + '?format=json', {
    method: method,
    headers: {
      Authorization: "Token " + localStorage.token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).then(checkStatus)
    .catch(function(errors) {
      cb = failCb;
      return handleError(errors);
    })
    .then(parseJSON)
    .then(function(result) {
      if(cb != undefined && delay > 0) {
        setTimeout(function() {
          cb(result);
        }, delay);
      } else if(cb != undefined) {
        cb(result);
      }
    });
}

export function sendFormData(url, method, data, successCb, failCb, delay) {
  let cb = successCb;
  fetch(serverUrl+'/api/v1/' + url, {
    method: method,
    headers: {
      Authorization: "Token " + localStorage.token,
    },
    body: data,
  }).then(checkStatus)
    .then(parseJSON)
    .catch(function(errors) {
      cb = failCb;
      return handleError(errors);
    })
    .then(function(result) {
      if(cb != undefined && delay > 0) {
        setTimeout(function() {
          cb(result);
        }, delay);
      } else if(cb != undefined) {
        cb(result);
      }
    });
}



/** WEBPACK FOOTER **
 ** ./src/actions/actionUtils.js
 **/